import styles from "./ViewPreview.module.scss";
import Assets from "../../../../assets/Assets";

const ViewPreview = ({ data }) => {
  const headings = data?.headings || [];

  const renderHeading = (item, index) => {
    if (!item) return null;

    const Tag = item.size || "h2"; // h1 | h2 | h3
    const text = item.heading;
    return (
      <Tag
        key={index}
        style={{ color: item.color || "#000" }}
        className={styles[`heading_${Tag}`]}
      >
        {text}
      </Tag>
    );
  };

  const isTopPosition = data?.heading_position?.toString() === "1" || !data?.heading_position;
  const isBottomPosition = data?.heading_position?.toString() === "2";
  const isDynamicProductStore =
    data?.content_type?.toString() === "2" &&
    (data?.dynamic_type === "product" || data?.dynamic_type === "store");
  const isWithLogoImage =
    data?.content_type?.toString() === "1" &&
    data?.heading_position?.toString() === "1";
  return (
    <div className={styles.posterWrapper}>
      <div
        className={styles.posterContainer}
        style={
          data?.image_full_url
            ? {
                backgroundImage: `url(${data?.image_full_url})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
              }
            : {}
        }
      >
        {/* Content */}
        <div className={styles.content}>
          {/* Headings - Top Position */}
          {isTopPosition && !isDynamicProductStore && (
            <div
              className={`${styles.headings}  ${
                isWithLogoImage ? styles.headingsTop : ""
              }`}
            >
              {headings.map((item, index) => renderHeading(item, index))}
            </div>
          )}
          {/* CTA Button - Only for Top Position */}
          {isTopPosition && data?.is_button === 1 && !isDynamicProductStore && (
            <button
              className={styles.ctaButton}
              style={{
                backgroundColor: data?.button_color || "#000",
                color: data?.button_text_color || "#000000",
              }}
            >
              {data?.alias_button_text || data?.button_text || "Start My Recap"}
            </button>
          )}
          {/* Spacer to push bottom content down */}
          {isBottomPosition && <div className={styles.spacer} />}
          {/* Headings - Bottom Position */}
          {isBottomPosition && !isDynamicProductStore && (
            <div className={styles.headingsBottom}>
              {headings.map((item, index) => renderHeading(item, index))}
            </div>
          )}
          {isDynamicProductStore && (
            <div className={styles.dynamicImageWrapper}>
              <img src={Assets?.DYNAMIC_PRODUCT} alt={data?.dynamic_type} />
            </div>
          )}
          {/* CTA Button - Bottom Position */}
          {isBottomPosition &&
            data?.is_button === 1 &&
            !isDynamicProductStore && (
              <button
                className={styles.ctaButtonBottom}
                style={{
                  backgroundColor: data?.button_color || "#4ade80",
                  color: data?.button_text_color || "#000000",
                }}
              >
                {data?.alias_button_text ||
                  data?.button_text ||
                  "Start My Recap"}
              </button>
            )}
        </div>
      </div>
    </div>
  );
};

export default ViewPreview;
